
import { fetchRequest } from './';
import {  NCNBReason, WorksheetId } from './domain';
import { worksheetMessage, WorksheetResult } from './worksheet-service';

const service = 'ncnbreason';

export type NCNBResult = WorksheetResult<NCNBReason>;
export type NCNBReasonsListResult = WorksheetResult<NCNBReason[]>;

export const addNCNBReasonsRequest = fetchRequest<NCNBReason, NCNBResult>({
  method: 'post',
  body: (args: NCNBReason) => worksheetMessage(args, 'addreason', service),
});

export const updateNCNBReasonRequest = fetchRequest({
  method: 'post',
  body: (args: NCNBReason) => worksheetMessage(args, 'updatereason', service),
});

export const getNCNBReasonsRequest = fetchRequest({
  method: 'post',
  body: (args: WorksheetId) => worksheetMessage(args, 'getreasons', service),
  notFoundResult: () => ({ result: [] }),
});

interface NCNBReasonsIds extends WorksheetId {
  ncnbReasonId: string;
}
export type DowncodeIdsResult = WorksheetResult<any>;

export const deleteNCNBReasons = fetchRequest({
  method: 'post',
  body: (args: NCNBReasonsIds) =>
    worksheetMessage(args, 'deletereason', service),
});
